export default "__VITE_ASSET__d68c5898__"